<dx-data-grid
[dataSource]="dataSource"
[showBorders]="true"
[focusedRowEnabled]="true"
[focusedRowIndex]="0"
[columnAutoWidth]="true"
[columnHidingEnabled]="false"
[showColumnLines]="true"
[showRowLines]="true"
(onRowUpdating)="onUpdating($event)"
(onExporting)="onExporting($event)"
>

<dxo-export [enabled]="true"></dxo-export>
<dxo-editing
    mode="row"
    [allowAdding]="true"
    [allowUpdating]="true"
    [allowDeleting] ="true"
    [useIcons]="true"
>
<dxo-texts confirmDeleteMessage="Confermare la cancellazione?"></dxo-texts>  
</dxo-editing>


<dxo-paging [pageSize]="10"></dxo-paging>
<dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
<dxo-filter-row [visible]="true"></dxo-filter-row>
<dxi-column type="buttons" [buttons]="['edit', 'delete']"></dxi-column>
<dxi-column
    dataField="id"
    [formItem]="{ visible: false }"
    [visible]="false" 
    [allowEditing]="false">
</dxi-column>

<dxi-column
    dataField="eseguito"
    width="100" >
</dxi-column>

<dxi-column
    dataField="data"
    caption="Data"
    format="dd/MM/yyyy"
    dataType="date"
    width="150"
    [sortIndex]="1"
    sortOrder="desc">
<dxi-validation-rule type="required" message="Selezionare la data"></dxi-validation-rule>
</dxi-column>


<dxi-column
    dataField="descrizione">
    <dxi-validation-rule type="required" message="Inserire la descrizione"></dxi-validation-rule>
</dxi-column> 

 

<dxo-paging 
    [pageSize]="20">
</dxo-paging>
<dxo-pager 
    visible="true" 
    allowedPageSizes="true" 
    displayMode="full"
    showPageSizeSelector="true" 
    showInfo="true" 
    showNavigationButtons="true">
</dxo-pager>

</dx-data-grid>